var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485.5 485.5",
    style: {
      enableBackground: "new 0 0 485.5 485.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;fill:#1E3050;}\r\n\t.st1{fill:#1E3050;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485.5,242.8c0,134.1-108.7,242.8-242.8,242.8S0,376.8,0,242.8S108.7,0,242.8,0S485.5,108.7,485.5,242.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M354.4,162.4c9.8,9.8,9.8,25.7,0,35.4L229.1,323.1c-9.8,9.8-25.6,9.8-35.4,0c0,0,0,0,0,0l-62.7-62.6 c-9.8-9.8-9.8-25.6,0-35.4s25.6-9.8,35.4,0l44.2,44.9L319,162.4C328.8,152.6,344.6,152.6,354.4,162.4 C354.4,162.4,354.4,162.4,354.4,162.4L354.4,162.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.759de562f9cea333aa375a89a61cf122.svg";
export { ForwardRef as ReactComponent };